import React, { Component } from 'react';
import { Box } from 'core/components';
import styled from 'styled-components';
import Markdown from 'app/components/markdown/Markdown';
import ToolResultCard from '../components/ToolResultCard';

// reduce some of the margins of headings for tool debug
const ToolMarkdownWrap = styled(Box)`
  h3,
  h4 {
    margin-top: 0;
  }
`;

class WhoisToolResult extends Component {
  render() {
    const { tool, onCloseToolResult, isInlineMode } = this.props;
    const { processed_result } = tool;

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        isInlineMode={isInlineMode}
        className="tool-result-whois"
        title={tool.title || 'Whois Tool Result'}
        minHeight={450}
        overflow="auto"
      >
        <ToolMarkdownWrap>
          <Markdown>{processed_result}</Markdown>
        </ToolMarkdownWrap>
      </ToolResultCard>
    );
  }
}

export default WhoisToolResult;
